// document.title = 'ONCE 360° Viewer 12.18';

// 共通の設定：sessionStorageで使うキー名
// const STORAGE_KEY = 'sp_modal_mode';

const modelViewer = document.querySelector('#modelViewer');

const wrapperViewer = document.querySelector('.wrapper-viewer');
// Mobile用の画面表示（css制御）
// wrapperViewer.classList.add("modal-sp");

const container = document.querySelector('.container');

function setVisibility(visible) {
  dimElements.forEach((element) => {
    if (visible) {
      element.classList.remove('hide');
    } else {
      element.classList.add('hide');
    }
  });
}

// omi追加
function getViewerAssets() {
  const productId = window.__productIdForViewer;
  if (!productId) return null;

  const el = document.querySelector(`#viewerAssets-${productId}`);
  if (!el) return null;

  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return null;
  }
}

// update svg
function drawLine(svgLine, dotHotspot1, dotHotspot2, dimensionHotspot) {
  if (dotHotspot1 && dotHotspot2) {
    svgLine.setAttribute('x1', dotHotspot1.canvasPosition.x);
    svgLine.setAttribute('y1', dotHotspot1.canvasPosition.y);
    svgLine.setAttribute('x2', dotHotspot2.canvasPosition.x);
    svgLine.setAttribute('y2', dotHotspot2.canvasPosition.y);

    // use provided optional hotspot to tie visibility of this svg line to
    if (dimensionHotspot && !dimensionHotspot.facingCamera) {
      svgLine.classList.add('hide');
    } else {
      svgLine.classList.remove('hide');
    }
  }
}

// model-viewerで初めに読み込まれる属性を設定する（FourとTwoなどの違い）

// 商品名の登録
const productName = modelViewer.dataset.productname; // data属性の値（名称）は「productname」
// 商品名
const textProductName = document.querySelector('.product-name');
textProductName.textContent = productName;

// ファイルの相対パス
const relativePathGLB = './src/assets/glb/';
const relativePathSVG = './src/assets/images/';

const fileSVG = [
  `${relativePathSVG}fullscreen_exit_24dp_585B69_FILL0_wght300_GRAD-25_opsz24.svg`,
  `${relativePathSVG}crop_free_24dp_585B69_FILL0_wght300_GRAD-25_opsz24.svg`,
];

const dimLines = modelViewer.querySelectorAll('line');

// 寸法線を引く 同時に寸法線の表示非表示の設定
const renderSVG = () => {
  // 寸法線 W 奥
  drawLine(
    dimLines[0],
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET-Z'), // 8B
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET-Z'), // 3B
    modelViewer.queryHotspot('hotspot-dim-Y+Z') // W中央 下 手前
  );
  // 寸法線 W 手前
  drawLine(
    dimLines[1],
    modelViewer.queryHotspot('hotspot-dot-X-Y+Z+OFFSET+Z'), // 2B
    modelViewer.queryHotspot('hotspot-dot+X-Y+Z+OFFSET+Z'), // 5B
    modelViewer.queryHotspot('hotspot-dim-Y-Z') // W中央 下 手前
  );
  // 寸法線 H 左
  drawLine(
    dimLines[2],
    modelViewer.queryHotspot('hotspot-dot-X+Y-Z+OFFSET-Z'), // 6B
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET-Z'), // 8B
    modelViewer.queryHotspot('hotspot-dim-X-Z') // 左 H中央 手前
  );
  // 寸法線 H 右
  drawLine(
    dimLines[3],
    modelViewer.queryHotspot('hotspot-dot+X+Y-Z+OFFSET-Z'), // 1B
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET-Z'), // 3B
    modelViewer.queryHotspot('hotspot-dim+X-Z') // H中央 右 手前
  );
  // 寸法線 D 左
  drawLine(
    dimLines[4],
    modelViewer.queryHotspot('hotspot-dot-X-Y+Z+OFFSET-X'), // 2A
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET-X'), // 8A
    modelViewer.queryHotspot('hotspot-dim-X-Y') // 左 下 D中央
  );
  // 寸法線 D 右
  drawLine(
    dimLines[5],
    modelViewer.queryHotspot('hotspot-dot+X-Y+Z+OFFSET+X'), // 5A
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET+X'), // 3A
    modelViewer.queryHotspot('hotspot-dim+X-Y') // 左 下 D中央
  );
  // 寸法線 H T字 左
  drawLine(
    dimLines[6],
    modelViewer.queryHotspot('hotspot-dot-X+Y-Z+OFFSET-Z+T'), // 6BT-1
    modelViewer.queryHotspot('hotspot-dot-X+Y-Z+OFFSET-Z-T'), // 6BT-2
    modelViewer.queryHotspot('hotspot-dim-X-Z') // 左 H中央 手前
  );
  // 寸法線 H T字 右
  drawLine(
    dimLines[7],
    modelViewer.queryHotspot('hotspot-dot+X+Y-Z+OFFSET-Z+T'), // 1BT-1
    modelViewer.queryHotspot('hotspot-dot+X+Y-Z+OFFSET-Z-T'), // 1BT-2
    modelViewer.queryHotspot('hotspot-dim+X-Z') //
  );
  // 寸法線 W 前 T字 左
  drawLine(
    dimLines[8],
    modelViewer.queryHotspot('hotspot-dot-X-Y+Z+OFFSET+Z+T'), // 2BT-1
    modelViewer.queryHotspot('hotspot-dot-X-Y+Z+OFFSET+Z-T'), // 2BT-2
    modelViewer.queryHotspot('hotspot-dim-Y-Z') //
  );
  // 寸法線 W 前 T字 右
  drawLine(
    dimLines[9],
    modelViewer.queryHotspot('hotspot-dot+X-Y+Z+OFFSET+Z-T'), // 5BT-1
    modelViewer.queryHotspot('hotspot-dot+X-Y+Z+OFFSET+Z+T'), // 5BT-2
    modelViewer.queryHotspot('hotspot-dim-Y-Z') //
  );
  // 寸法線 W 奥 T字 左
  drawLine(
    dimLines[10],
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET-Z-T'), // 3BT-1
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET-Z+T'), // 3BT-2
    modelViewer.queryHotspot('hotspot-dim-Y+Z') //
  );
  // 寸法線 W 奥 T字 右
  drawLine(
    dimLines[11],
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET+Z+T'), // 8BT-1
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET+Z-T'), // 8BT-2
    modelViewer.queryHotspot('hotspot-dim-X-Z') //
  );
  // 寸法線 D 右 T字 奥
  drawLine(
    dimLines[12],
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET+X-T'), // 3AT-1
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET+X+T'), // 3AT-2
    modelViewer.queryHotspot('hotspot-dim+X-Y') //
  );
  // 寸法線 D 右 T字 前
  drawLine(
    dimLines[13],
    modelViewer.queryHotspot('hotspot-dot+X-Y+Z+OFFSET+X-T'), // 5AT-1
    modelViewer.queryHotspot('hotspot-dot+X-Y+Z+OFFSET+X+T'), // 5AT-2
    modelViewer.queryHotspot('hotspot-dim+X-Y') //
  );
  // 寸法線 D 左 T字 奥
  drawLine(
    dimLines[14],
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET-X-T'), // 8AT-1
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET-X+T'), // 8AT-2
    modelViewer.queryHotspot('hotspot-dim-X-Y') //
  );
  // 寸法線 D 左 T字 前
  drawLine(
    dimLines[15],
    modelViewer.queryHotspot('hotspot-dot-X-Y+Z+OFFSET-X-T'), // 2AT-1
    modelViewer.queryHotspot('hotspot-dot-X-Y+Z+OFFSET-X+T'), // 2AT-2
    modelViewer.queryHotspot('hotspot-dim-X-Y') //
  );
  // 寸法線 H 奥 T字 下
  drawLine(
    dimLines[16],
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET-Z-T'), // 3BT-1
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET-Z+T'), // 3BT-2
    modelViewer.queryHotspot('hotspot-dim+X-Z') //
  );
  // 寸法線 H 奥 T字 下
  drawLine(
    dimLines[17],
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET+Z+T'), // 8BT-1
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET+Z-T'), // 8BT-2
    modelViewer.queryHotspot('hotspot-dim-Y+Z') //
  );
};

// -------------------- 🔴ローディング要素 --------------------

// Progress Bar
const progressBar = document.querySelector('.progress-bar');

// Overlay
const overlay = document.querySelector('.overlay');

// -------------------- 🔴各種ボタン要素 --------------------

// ボタン一式
const wrapperButton = document.querySelector('.wrapper-button');
const wrapperButtonOption = document.querySelector('.wrapper-button-option');

// AR」ボタン
const btnAR = document.querySelector('.viewer-ui-ar');

// Fullscreen ボタン
const btnFullscreen = document.querySelector(
  '.wrapper-button-option .viewer-ui-fullscreen'
);

// Dimensions ボタン
const btnDimensions = document.querySelector('.viewer-ui-dimensions');

// Open ボタン
const btnOpen = document.querySelector('.viewer-ui-open');

// Hide ボタン
const btnHide = document.querySelector('.viewer-ui-hide');

// Refresh ボタン
const btnRefresh = document.querySelector('.viewer-ui-refresh');

// -------------------- 🔴各種ボタン付加要素 --------------------

// Fullscreen ボタン 付加要素
const btnFullscreenIcon = document.querySelector(
  '.wrapper-button-option .viewer-ui-fullscreen .material-symbols-outlined'
);
const btnFullscreenExit = btnFullscreen.querySelector('.ui-circle img');

// Dimensions ボタン 付加要素
const btnDimensionsActive = document.querySelector(
  '.viewer-ui-dimensions .ui-circle'
);

// Open Flap ボタン 付加要素
const btnOpenText = document.querySelector('.state-open');
const btnOpenActive = document.querySelector('.viewer-ui-open .ui-circle');

// Open Flap ボタン 付加要素
const btnOpenIconOn = document.querySelector('.toggle-open.default');
const btnOpenIconOff = document.querySelector('.toggle-open.active');

// Hide Flap ボタン 付加要素
const btnHideText = document.querySelector('.state-hide');
const btnHideActive = document.querySelector('.viewer-ui-hide .ui-circle');

// Hide Flap ボタン 付加要素
const btnHideIconOn = document.querySelector('.toggle-hide.default');
const btnHideIconOff = document.querySelector('.toggle-hide.active');

// -------------------- 🔴model-viewer 内要素 --------------------

// Dimensions 要素一式
const dimElements = [
  ...modelViewer.querySelectorAll('.button'),
  modelViewer.querySelector('#dimLines'),
];
// Dimensions 寸法要素
const dim = document.querySelectorAll('.dim');
// Dimensions 線のコンテナ
const dimensionLineContainer = modelViewer.querySelector(
  '.dimensionLineContainer'
);

const controlMenu = document.querySelector('#controls'); // 🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡

// ボタン選択時のカラー設定
// アクティブカラー
const colorActive = '#efefef';
// 非アクティブカラー
const colorInactive = '#ffffff';

const colorActiveUI = 'rgb(250 250 250 / 1)';

const colorInActiveUI = 'rgb(250 250 250 / 0.8)';

// フラップの設置サイズ 30,45,0
const flapPattern = 'flap30';

// -------------------- 🔴カラーコード(#RGB)を model-viewer用の配列 [r, g, b, 1] に変換する関数 --------------------
// 色変更用に設定
function hexToRgba(hex) {
  // #があれば取り除く
  hex = hex.replace('#', '');

  // 16進数を10進数(0-255)に戻して、255で割って0-1にする
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;

  return [r, g, b, 1.0];
}

document.addEventListener('DOMContentLoaded', (event) => {
  // もしモデルが見つからなかったら、ここで処理を終わらせる
  if (!modelViewer) return;

  // model-viewerがロードされたタイミングなどでチェック
  // ARが使えない端末（PCなど）なら、ボタンを非表示にする
  if (modelViewer.canActivateAR) {
    // --- スマホ (AR対応) の場合 ---
    btnAR.style.display = 'none'; // ARボタンを表示
    btnFullscreen.style.display = 'none'; // フルスクリーンボタンを隠す

    // Mobileのフルスクリーン用
    const touchAction = 'none';
    // touch-action属性を直接書き換える
    modelViewer.setAttribute('touch-action', touchAction);

    // --------------------------------------------------------------------------------------
    if (!wrapperViewer.classList.contains('modal-sp')) {
      wrapperViewer.style.aspectRatio = '3/4';
    }

    // 1. 保存されている状態を読み込む (なければ 'OFF' がデフォルト)
    // const currentStatus = sessionStorage.getItem(STORAGE_KEY) || 'OFF';

    // 2. 状態に合わせてbodyにクラスを付与
    // if (currentStatus === 'ON') {
    //     wrapperViewer.classList.add('modal-mode-on');
    // }

    // 3. トップページにボタンがある場合、ボタンのテキストを初期化
    // const btn = document.getElementById('mode-toggle-btn');
    // if (btn) {
    //     updateButtonText(btn, currentStatus);

    //     // ボタンクリック時のイベント
    //     btn.addEventListener('click', () => {
    //         const isNowOn = wrapperViewer.classList.contains('modal-mode-on');

    //         if (isNowOn) {
    //             // ONからOFFへ
    //             wrapperViewer.classList.remove('modal-mode-on');
    //             sessionStorage.setItem(STORAGE_KEY, 'OFF');
    //             updateButtonText(btn, 'OFF');
    //         } else {
    //             // OFFからONへ
    //             wrapperViewer.classList.add('modal-mode-on');
    //             sessionStorage.setItem(STORAGE_KEY, 'ON');
    //             updateButtonText(btn, 'ON');
    //         }
    //     });
    // }
    // // --------------------------------------------------------------------------------------
    // Mobile用の画面表示（css制御）
    // wrapperViewer.classList.add("modal-sp");
    // wrapperViewer.style.margin = "15px";
  } else {
    // --- PC (AR非対応) の場合 ---
    btnAR.style.display = 'none'; // ARボタンを隠す
    btnFullscreen.style.display = 'flex'; // フルスクリーンボタンを表示

    // if (!wrapperViewer.classList.contains("modal-sp")) {
    //     document.body.style.padding = "15px";
    //     document.body.style.backgroundColor = "red";
    //     wrapperViewer.height = "700px";
    // }
    // wrapperViewer.style.margin = "15px";
  }

  // -------------------- 🔴ロード後にmodel-viewの属性名を取得 --------------------
  // <model-viewer>で設定した初期値を保存
  const initial = {
    cameraOrbit: modelViewer.getAttribute('camera-orbit'),
    maxCameraOrbit: modelViewer.getAttribute('max-camera-orbit'),
    cameraTarget: modelViewer.getAttribute('camera-target'),
    fieldOfView: modelViewer.getAttribute('field-of-view'),
    animationName: modelViewer.getAttribute('animation-name'),
    src: modelViewer.getAttribute('src'),
  };
  // const src = el.getAttribute('src');

  // -------------------- 🔴ロード後にmodel-viewの属性名を取得 --------------------

  console.log(`
        1. camera-orbit: ${initial.cameraOrbit};
        2. max-camera-orbit: ${initial.maxCameraOrbit};
        3. cameraTarget: ${initial.cameraTarget};
        4. field-of-view: ${initial.fieldOfView};
        5. animation-name: ${initial.animationName};
        6. src: ${initial.src};
    `);

  // -------------------- 🔴model-viewer のカメラ属性の初期設定 --------------------

  // 読み込むモデル「Four」か「Two」によってカメラターゲットを変更する処理

  // 1. カメラターゲットの設定
  const cameraTargetTwo = '0m 0.4m 0m';
  const cameraTargetFour = '0m 0.73m 0m';

  // 2. ファイル名取得
  const fileName = initial.src;

  // 3. 読み込むファイル名に特定の文字列特定文字列「Four」が含まれるか確認して処理する
  if (fileName.includes('Four')) {
    // 含まれている時の処理
    console.log('特定文字列「Four」が含まれています:', fileName);

    // 直接書き換える
    modelViewer.setAttribute('camera-target', cameraTargetFour);
    // 変数で書き換える
    // modelViewer.cameraTarget = cameraTargetFour;

    // doActionA();
  } else {
    // 含まれていない時の処理
    console.log('特定文字列はありません:', fileName);
    // doActionB();
    // 直接書き換える
    modelViewer.setAttribute('camera-target', cameraTargetTwo);
    // 変数で書き換える
    // modelViewer.cameraTarget = cameraTargetTwo;
  }

  // -------------------- 🔴model-viewer 読み込み進捗検知 --------------------

  modelViewer.addEventListener('progress', (event) => {
    progressBar.style.width = `${(event.detail.totalProgress * 100) / 2}%`;

    if (event.detail.totalProgress >= 0.9) {
      progressBar.style.width = '50%';
      progressBar.classList.add('hide');
    }
  });

  // -------------------- 🔴model-viewer 読み込み完了検知 --------------------

  modelViewer.addEventListener('load', () => {
    // -------------------- 🔴読み込み後の処理 --------------------
    // Dimensionsの線のコンテナを非表示（初期値）
    dimensionLineContainer.style.display = 'none';

    // -------------------- 🔴GLBファイルの情報取得 --------------------
    // アニメーション名の取得
    // availableAnimations はアニメーション名の配列を返す
    const animations = modelViewer.availableAnimations;
    console.log(`🔴 Name of Animations:${animations[0]}`);
    if (animations[0] === undefined) {
      console.log(`🔴 なし`);
      wrapperViewer.classList.add('noFlap');
    }

    // マテリアル全リストを取得
    const materials = modelViewer.model.materials;
    console.log(`materials: ${materials[0]}`);

    // 名前だけを抽出して配列にする
    const materialNames = materials.map((material) => material.name);

    // 各マテリアルに対してループ処理
    materials.forEach((material, index) => {
      const matName = material.name;
      console.log(`Index ${index}: ${material.name}`);
      console.log('Name of Materials:', matName);

      // パターン1: 「Aluminum」が含まれるものすべて（部分一致）
      // Aluminum, Aluminum_plate_left の両方がここでヒットします
      const src = modelViewer.getAttribute('src');
      if (src.includes('blue')) {
        // applyCommonAluminumStyle(material);

        const colorArray = hexToRgba('252f37');
        // テクスチャを剥がす
        // material.pbrMetallicRoughness.baseColorTexture.setTexture(null);
        applySpecificColorStyle(material, colorArray);
      }
      if (src.includes('green')) {
        const colorArray = hexToRgba('32342a');
        // テクスチャを剥がす
        // material.pbrMetallicRoughness.baseColorTexture.setTexture(null);
        applySpecificColorStyle(material, colorArray);
      }

      // パターン2: 「Aluminum_plate_left」だけ（完全一致）
      // 特定のパーツだけにさらに追加処理をしたい場合
      if (matName === 'Aluminum') {
        // const colorArray = hexToRgba("6a6b6f");
        const colorArray = hexToRgba('c8c8c8');

        // ▼ 反射の設定を変更

        // Metallic（金属度）を設定 [0.0 ～ 1.0]
        // 0.0 = プラスチック・陶器風
        // 1.0 = 金属風

        // Roughness（粗さ）を設定 [0.0 ～ 1.0]
        // 0.0 = 超ツルツル（反射最強）
        // 0.5 = 半光沢
        // 1.0 = ツヤ消し（反射なし）
        material.pbrMetallicRoughness.setMetallicFactor(1);
        material.pbrMetallicRoughness.setRoughnessFactor(0.2);
        // material.pbrMetallicRoughness.setRoughnessFactor(0);
        applySpecificColorStyle(material, colorArray);
      }

      if (matName.includes('plate')) {
        const colorArray = hexToRgba('777777');
        applySpecificColorStyle(material, colorArray);
      }

      if (matName.includes('Flap')) {
        const colorArray = hexToRgba('c8c8c8');
        material.pbrMetallicRoughness.setMetallicFactor(1);
        material.pbrMetallicRoughness.setRoughnessFactor(0.2);
        applySpecificColorStyle(material, colorArray);
      }

      if (matName.includes('highlights')) {
        const colorArray = hexToRgba('ffffff');
        applySpecificColorStyle(material, colorArray);
        if (matName.includes('blue')) {
          const colorArray = hexToRgba('829bb4');
          applySpecificColorStyle(material, colorArray);
        }
        if (matName.includes('green')) {
          const colorArray = hexToRgba('8B8A7B');
          applySpecificColorStyle(material, colorArray);
        }
      }

      if (matName.includes('Flap_30_bake')) {
        wrapperViewer.classList.add('flap30');
        console.log(`🟡flapPattern: flap30`);
      }
      if (matName.includes('Flap_45_bake')) {
        wrapperViewer.classList.add('flap45');
        console.log(`🟡flapPattern: flap45`);
      }
    });

    // オブジェクト毎にカラーを設定
    function applySpecificColorStyle(material, colorArray) {
      material.pbrMetallicRoughness.setBaseColorFactor(colorArray);
    }

    // Flapアニメーションを初期位置にセット
    function setAnimationReset() {
      // 【重要】強制的に開始位置(0秒)へ戻す
      modelViewer.pause();
      modelViewer.currentTime = 0;
      modelViewer.timeScale = 1;

      console.log('🔴Animation: 時間を0にリセット');
    }

    // Flapボタン関連の表示関数
    function setBtnVisibility(boolean) {
      if (boolean) {
        btnOpen.style.display = 'flex';
        btnHide.style.display = 'flex';

        // ボタンが少ない時、Refreshボタンを非アクティブに
        btnRefresh.style.width = '28px';
        // btnRefresh.classList.remove("active");
      } else {
        btnOpen.style.display = 'none';
        btnHide.style.display = 'none';

        // ボタンが少ない時、Refreshボタンをアクティブに
        btnRefresh.style.width = '82px';
        // btnRefresh.classList.add("active");
      }
    }

    // Flapボタン関連の初期状態状態管理（アニメーション名の有無で表示制御）
    if (animations.length > 0) {
      setBtnVisibility(true);

      // アニメーションの初期位置へリセット
      setAnimationReset();
    } else {
      setBtnVisibility(false);
    }

    // -------------------- 🔴Console 出力 --------------------

    console.log(`Animations: ${animations}`);
    console.log(`Materials: ${materialNames}`);

    const materialWood = modelViewer.model.materials[0];
    const materialScrew = modelViewer.model.materials[1];
    const materialAluminum = modelViewer.model.materials[2];
    const materialSpacer = modelViewer.model.materials[3];

    // materialWood.pbrMetallicRoughness.setMetallicFactor(0.3);

    // materialWood.pbrMetallicRoughness.setRoughnessFactor(0.3);

    // console.log(`ラフネス${modelViewer.model.materials[0].metalness}`);

    // const colorArray = hexToRgba("73818E");
    // const colorArray = hexToRgba("758391");
    // materialWood.pbrMetallicRoughness.setBaseColorFactor(colorArray);

    // const colorArray = hexToRgba("FFFFFF");
    // const material = modelViewer.model.materials[0];
    // テクスチャを剥がして色だけにする場合
    // materialAluminum.pbrMetallicRoughness.baseColorTexture.setTexture(null);
    // materialAluminum.pbrMetallicRoughness.setBaseColorFactor(colorArray);
    // materialAluminum.pbrMetallicRoughness.setRoughnessFactor(0.0);
    // materialAluminum.pbrMetallicRoughness.setMetallicFactor(1.0);

    // -------------------------------------- Dimensions ボタン 表示非表示
    // 属性の初期化（モデルの初期ロード時の初期値にリセットする）
    // btnDimensions.addEventListener('click', () => {
    //   const btnSelected = dimensionLineContainer.style.display === 'none';

    //   btnDimensions.classList.toggle('selected', btnSelected);

    //   setDimensionVisibility(btnSelected);
    // });

    // // -------------------------------------- 3Dモデル Flap開閉ボタン
    // // 属性の初期化（モデルの初期ロード時の初期値にリセットする）
    // btnOpen.addEventListener('click', () => {
    //   actionOpen();
    // });

    // // -------------------------------------- 3Dモデル Flap非表示ボタン

    // btnHide.addEventListener('click', () => {
    //   actionHide();
    // });

    // // -------------------------------------- 3Dモデル Refresh
    // // 属性の初期化（モデルの初期ロード時の初期値にリセットする）
    // btnRefresh.addEventListener('click', () => {
    //   runRefresh();
    // });

    // -------------------------------------- Dimensions 非表示（初期化）
    setDimensionVisibility(false);
    dim.forEach((element) => {
      element.style.display = 'none';
    });

    // ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    const center = modelViewer.getBoundingBoxCenter();
    const size = modelViewer.getDimensions();
    const x2 = size.x / 2;
    const y2 = size.y / 2;
    const z2 = size.z / 2;

    // 小数第1位までの場合はそのまま表示、整数の場合は小数点なし
    function formatNumber(num) {
      const fixed = num.toFixed(1); // 小数点1桁に丸める
      return fixed.endsWith('.0') ? fixed.slice(0, -2) : fixed;
    }

    // 🔴ラベル W 手前
    modelViewer.querySelector(
      'button[slot="hotspot-dim-Y-Z"]'
    ).textContent = `W: ${formatNumber(size.x * 100)}cm`;
    // 🔴ラベル W 奥
    modelViewer.querySelector(
      'button[slot="hotspot-dim-Y+Z"]'
    ).textContent = `W: ${formatNumber(size.x * 100)}cm`;
    // 🔴ラベル D 左
    modelViewer.querySelector(
      'button[slot="hotspot-dim-X-Y"]'
    ).textContent = `D: ${formatNumber(size.z * 100)}cm`;
    // 🔴ラベル D 右
    modelViewer.querySelector(
      'button[slot="hotspot-dim+X-Y"]'
    ).textContent = `D: ${formatNumber(size.z * 100)}cm`;
    // 🔴ラベル H 左
    modelViewer.querySelector(
      'button[slot="hotspot-dim-X-Z"]'
    ).textContent = `H: ${formatNumber(size.y * 100)}cm`;
    // 🔴ラベル H 右
    modelViewer.querySelector(
      'button[slot="hotspot-dim+X-Z"]'
    ).textContent = `H: ${formatNumber(size.y * 100)}cm`;

    const offsetLabel = 2;
    // Hotspotからのオフセットの距離 m（メートル）
    const offsetDistance = 0.18;
    const offsetDistanceT = 0.05;

    // 🔴ラベルx,y,z座標 W 手前
    modelViewer.updateHotspot({
      name: 'hotspot-dim-Y-Z',
      position: `${center.x} ${0} ${center.z + z2 * offsetLabel}`,
    });
    // 🔴ラベルx,y,z座標 W 奥
    modelViewer.updateHotspot({
      name: 'hotspot-dim-Y+Z',
      position: `${center.x} ${0} ${center.z + z2 * -offsetLabel}`,
    });
    // 🔴ラベルx,y,z座標 D 左
    modelViewer.updateHotspot({
      name: 'hotspot-dim-X-Y',
      position: `${center.x - x2 - offsetDistance} ${center.y - y2} ${
        center.z
      }`, // ラベルの位置調整 X
    });
    // 🔴ラベルx,y,z座標 D 右
    modelViewer.updateHotspot({
      name: 'hotspot-dim+X-Y',
      position: `${center.x + x2 + offsetDistance} ${center.y - y2} ${
        center.z
      }`, // ラベルの位置調整 X
    });
    // 🔴ラベルx,y,z座標 H 左
    modelViewer.updateHotspot({
      name: 'hotspot-dim-X-Z',
      position: `${center.x - x2} ${center.y} ${
        center.z - z2 - offsetDistance
      }`, // ラベルの位置調整 Z
    });
    // 🔴ラベルx,y,z座標 H 右
    modelViewer.updateHotspot({
      name: 'hotspot-dim+X-Z',
      position: `${center.x + x2} ${center.y} ${
        center.z - z2 - offsetDistance
      }`, // ラベルの位置調整 Z
    });
    // （1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X+Y-Z',
      position: `${center.x + x2} ${center.y + y2} ${center.z - z2}`,
    });
    // （1B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X+Y-Z+OFFSET-Z',
      position: `${center.x + x2} ${center.y + y2} ${
        center.z - z2 - offsetDistance
      }`,
    });
    // （1BT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X+Y-Z+OFFSET-Z+T',
      position: `${center.x + x2} ${center.y + y2} ${
        center.z - z2 - offsetDistance - offsetDistanceT
      }`,
    });
    // （1BT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X+Y-Z+OFFSET-Z-T',
      position: `${center.x + x2} ${center.y + y2} ${
        center.z - z2 - offsetDistance + offsetDistanceT
      }`,
    });
    // （2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z',
      position: `${center.x - x2} ${center.y - y2} ${center.z + z2}`,
    });
    // （2A）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z+OFFSET-X',
      position: `${center.x - x2 - offsetDistance} ${center.y - y2} ${
        center.z + z2
      }`, // ラベルの位置調整 X = -0.2
    });
    // （2AT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z+OFFSET-X-T',
      position: `${center.x - x2 - offsetDistance - offsetDistanceT} ${
        center.y - y2
      } ${center.z + z2}`, // ラベルの位置調整 X = -0.2
    });
    // （2AT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z+OFFSET-X+T',
      position: `${center.x - x2 - offsetDistance + offsetDistanceT} ${
        center.y - y2
      } ${center.z + z2}`, // ラベルの位置調整 X = -0.2
    });
    // （2B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z+OFFSET+Z',
      position: `${center.x - x2} ${center.y - y2} ${
        center.z + z2 + offsetDistance
      }`,
    });
    // （2BT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z+OFFSET+Z+T',
      position: `${center.x - x2} ${center.y - y2} ${
        center.z + z2 + offsetDistance - offsetDistanceT
      }`,
    });
    // （2BT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z+OFFSET+Z-T',
      position: `${center.x - x2} ${center.y - y2} ${
        center.z + z2 + offsetDistance + offsetDistanceT
      }`,
    });
    // （3）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z',
      position: `${center.x + x2} ${center.y - y2} ${center.z - z2}`,
    });
    // （3B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z+OFFSET-Z',
      position: `${center.x + x2} ${center.y - y2} ${
        center.z - z2 - offsetDistance
      }`,
    });
    // （3BT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z+OFFSET-Z-T',
      position: `${center.x + x2} ${center.y - y2} ${
        center.z - z2 - offsetDistance - offsetDistanceT
      }`,
    });
    // （3BT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z+OFFSET-Z+T',
      position: `${center.x + x2} ${center.y - y2} ${
        center.z - z2 - offsetDistance + offsetDistanceT
      }`,
    });
    // （3A）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z+OFFSET+X',
      position: `${center.x + x2 + offsetDistance} ${center.y - y2} ${
        center.z - z2
      }`, // ラベルの位置調整 X = +0.2
    });
    // （3AT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z+OFFSET+X-T',
      position: `${center.x + x2 + offsetDistance - offsetDistanceT} ${
        center.y - y2
      } ${center.z - z2}`, // ラベルの位置調整 X = -0.2
    });
    // （3AT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z+OFFSET+X+T',
      position: `${center.x + x2 + offsetDistance + offsetDistanceT} ${
        center.y - y2
      } ${center.z - z2}`, // ラベルの位置調整 X = +0.2
    });
    // （4）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X+Y+Z',
      position: `${center.x - x2} ${center.y + y2} ${center.z + z2}`,
    });
    // （5）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z',
      position: `${center.x + x2} ${center.y - y2} ${center.z + z2}`,
    });
    // （5A）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z+OFFSET+X',
      position: `${center.x + x2 + offsetDistance} ${center.y - y2} ${
        center.z + z2
      }`,
    });
    // （5AT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z+OFFSET+X-T',
      position: `${center.x + x2 + offsetDistance - offsetDistanceT} ${
        center.y - y2
      } ${center.z + z2}`,
    });
    // （5AT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z+OFFSET+X+T',
      position: `${center.x + x2 + offsetDistance + offsetDistanceT} ${
        center.y - y2
      } ${center.z + z2}`,
    });
    // （5B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z+OFFSET+Z',
      position: `${center.x + x2} ${center.y - y2} ${
        center.z + z2 + offsetDistance
      }`,
    });
    // （5BT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z+OFFSET+Z-T',
      position: `${center.x + x2} ${center.y - y2} ${
        center.z + z2 + offsetDistance - offsetDistanceT
      }`,
    });
    // （5BT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z+OFFSET+Z+T',
      position: `${center.x + x2} ${center.y - y2} ${
        center.z + z2 + offsetDistance + offsetDistanceT
      }`,
    });
    // （6）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X+Y-Z',
      position: `${center.x - x2} ${center.y + y2} ${center.z - z2}`,
    });
    // （6B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X+Y-Z+OFFSET-Z',
      position: `${center.x - x2} ${center.y + y2} ${
        center.z - z2 - offsetDistance
      }`,
    });
    // （6BT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X+Y-Z+OFFSET-Z+T',
      position: `${center.x - x2} ${center.y + y2} ${
        center.z - z2 - offsetDistance + offsetDistanceT
      }`,
    });
    // （6BT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X+Y-Z+OFFSET-Z-T',
      position: `${center.x - x2} ${center.y + y2} ${
        center.z - z2 - offsetDistance - offsetDistanceT
      }`,
    });
    // （7）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X+Y+Z',
      position: `${center.x + x2} ${center.y + y2} ${center.z + z2}`,
    });
    // （7B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X+Y+Z+OFFSET+Z',
      position: `${center.x + x2} ${center.y + y2} ${
        center.z + z2 + offsetDistance
      }`,
    });
    // （8）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z',
      position: `${center.x - x2} ${center.y - y2} ${center.z - z2}`,
    });
    // （8A）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z+OFFSET-X',
      position: `${center.x - x2 - offsetDistance} ${center.y - y2} ${
        center.z - z2
      }`,
    });
    // （8AT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z+OFFSET-X-T',
      position: `${center.x - x2 - offsetDistance - offsetDistanceT} ${
        center.y - y2
      } ${center.z - z2}`,
    });
    // （8AT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z+OFFSET-X+T',
      position: `${center.x - x2 - offsetDistance + offsetDistanceT} ${
        center.y - y2
      } ${center.z - z2}`,
    });
    // （8B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z+OFFSET-Z',
      position: `${center.x - x2} ${center.y - y2} ${
        center.z - z2 - offsetDistance
      }`,
    });
    // （8BT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z+OFFSET+Z+T',
      position: `${center.x - x2} ${center.y - y2} ${
        center.z - z2 - offsetDistance - offsetDistanceT
      }`,
    });
    // （8BT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z+OFFSET+Z-T',
      position: `${center.x - x2} ${center.y - y2} ${
        center.z - z2 - offsetDistance + offsetDistanceT
      }`,
    });

    renderSVG();

    modelViewer.addEventListener('camera-change', renderSVG);

    // -------------------- 🔴読み込み後の処理 --------------------
    // オーバーレイ非表示
    overlay.classList.add('hide');
    runRefresh();

    warmUpNextGLBs();
  });

  // -------------------- 🔴アニメーション終了の検知 --------------------

  modelViewer.addEventListener('finished', () => {
    console.log('✅ アニメーション終了');
  });

  // -------------------------------------- ARボタン
  btnAR.addEventListener('click', () => {
    modelViewer.activateAR();
  });

  // -------------------------------------- Fullscreen ボタン
  btnFullscreen.addEventListener('click', () => {
    const fullscreenActive = modelViewer.classList.contains('active');

    if (fullscreenActive) {
      document.exitFullscreen();
    } else {
      modelViewer.requestFullscreen();
    }
  });

  // omi追加（fullscreenchangさしかえ）
  document.addEventListener('fullscreenchange', () => {
    const assets = getViewerAssets();

    if (document.fullscreenElement) {
      console.log('Fullscreen Mode: ON');

      btnFullscreen.classList.add('selected');

      // Fullscreenアイコンの変更（Shopify asset）
      if (assets?.fullscreenOn) btnFullscreenExit.src = assets.fullscreenOn;

      dim.forEach((element) => {
        element.style.fontSize = '0.85rem';
      });

      [
        textProductName,
        modelViewer,
        wrapperButton,
        wrapperButtonOption,
        btnFullscreen,
        btnRefresh,
      ].forEach((el) => el.classList.add('active'));
    } else {
      console.log('Fullscreen Mode: OFF');

      btnFullscreen.classList.remove('selected');

      // Fullscreenアイコンの変更（Shopify asset）
      if (assets?.fullscreenOff) btnFullscreenExit.src = assets.fullscreenOff;

      dim.forEach((element) => {
        element.style.fontSize = '0.7rem';
      });

      [
        textProductName,
        modelViewer,
        wrapperButton,
        wrapperButtonOption,
        btnFullscreen,
        btnRefresh,
      ].forEach((el) => el.classList.remove('active'));
    }
  });

  // omi追加
  function applyARUI() {
    const canAR = !!modelViewer.canActivateAR;

    if (canAR) {
      btnAR.style.display = 'none';
      btnFullscreen.style.display = 'none';
      modelViewer.setAttribute('touch-action', 'none');
    } else {
      btnAR.style.display = 'none';
      btnFullscreen.style.display = 'flex';
    }

    console.log('[applyARUI] canActivateAR =', canAR);
  }

  // -------------------------------------- Open the Flap && Hide Flap
  //
  //パーツの表示・非表示を切り替える共通内部関数
  // @param {boolean} isVisible - 表示ならtrue, 非表示ならfalse
  //
  function updatePartsVisibility(isVisible, flap30, flap45, screw, spacer) {
    const is30 = wrapperViewer.classList.contains('flap30');
    const is45 = wrapperViewer.classList.contains('flap45');

    // 対象となるパーツを判定して配列に格納
    const targetParts = [];
    if (is30 || is45) {
      targetParts.push(screw, spacer);
      if (is30) targetParts.push(flap30);
      if (is45) targetParts.push(flap45);
    }

    // パーツの見た目を更新
    targetParts.forEach((part) => {
      part.pbrMetallicRoughness.setBaseColorFactor(
        isVisible ? [1, 1, 1, 1] : [1, 1, 1, 0]
      );
      part.setAlphaMode(isVisible ? 'OPAQUE' : 'BLEND');
    });

    // ログ出力用
    const logLabel =
      is30 && is45 ? '30+45' : is30 ? '30' : is45 ? '45' : 'no flap';
    console.log(`🟢flap${logLabel}`);
  }

  // モデル内のFlapを非表示にする
  function hidePart(flap30, flap45, screw, spacer) {
    // ボタンにクラス名追加
    btnHide.classList.add('selected');

    // Flapの位置を初期化する
    modelViewer.pause();
    modelViewer.timeScale = -1;
    modelViewer.currentTime = 0;
    modelViewer.play({
      repetitions: 1, // repetitions: 1 繰り返し回数
    });

    updatePartsVisibility(false, flap30, flap45, screw, spacer);
  }

  // モデル内のFlapを表示する
  function showPart(flap30, flap45, screw, spacer) {
    // ボタンからクラス名削除
    btnHide.classList.remove('selected');

    updatePartsVisibility(true, flap30, flap45, screw, spacer);
  }

  function runRefresh() {
    // ✅ カメラを初期値へ
    modelViewer.cameraOrbit = initial.cameraOrbit;
    modelViewer.fieldOfView = initial.fieldOfView;

    // ✅ 寸法OFF
    setDimensionVisibility(false);
    btnDimensions.classList.remove('selected');

    // ✅ flapがある場合の復帰
    if (!wrapperViewer.classList.contains('noFlap')) {
      modelViewer.pause();
      modelViewer.timeScale = -1;
      modelViewer.play({ repetitions: 1 });

      btnOpenIconOverlay('Close');
      btnOpen.classList.remove('selected');
      btnHide.classList.remove('selected');

      const materialFlap30 =
        modelViewer.model.getMaterialByName('Flap_30_bake');
      const materialFlap45 =
        modelViewer.model.getMaterialByName('Flap_45_bake');
      const materialSpacer = modelViewer.model.getMaterialByName('Spacer');
      const materialScrew =
        modelViewer.model.getMaterialByName('Screw-of-flap');

      btnHideIconOverlay('Show');
      showPart(materialFlap30, materialFlap45, materialScrew, materialSpacer);

      btnOpen.style.opacity = 1;
      btnOpen.style.pointerEvents = 'auto';
    }
  }

  // ✅ カラー切り替え＝src が変わったら UI を初期化して戻す
  let lastSrc = modelViewer.getAttribute('src');

  const resetUIForColorChange = () => {
    // 表示上のスイッチ状態を強制的に戻す
    btnHide.classList.remove('selected');
    btnOpen.classList.remove('selected');
    btnDimensions.classList.remove('selected');

    // 実体の状態も初期化（寸法OFF / flap表示 / flap閉じる / カメラ戻す 等）
    runRefresh();
  };

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'src') {
        const newSrc = modelViewer.getAttribute('src');
        if (!newSrc || newSrc === lastSrc) return;

        console.log('[viewer] src changed:', lastSrc, '->', newSrc);
        lastSrc = newSrc;

        // src 変わった瞬間に初期化（ロード前でもUIだけ先に戻してOK）
        resetUIForColorChange();
      }
    }
  });

  mo.observe(modelViewer, { attributes: true });

  modelViewer.addEventListener('load', () => {
    // ③ load 後は確実なのでここでもう一回
    applyARUI();
  });

  // -------------------------------------- Dimensions 表示非表示
  function setDimensionVisibility(visible) {
    const dimensionLineContainer = modelViewer.querySelector(
      '.dimensionLineContainer'
    );
    const dimElements = [
      ...modelViewer.querySelectorAll('.button'),
      modelViewer.querySelector('#dimLines'),
    ].filter(Boolean);
    const dim = document.querySelectorAll('.dim');

    if (visible) {
      if (dimensionLineContainer)
        dimensionLineContainer.style.display = 'block';
      dimElements.forEach((el) => el.classList.remove('hide'));
      dim.forEach((el) => (el.style.display = 'block'));
    } else {
      if (dimensionLineContainer) dimensionLineContainer.style.display = 'none';
      dimElements.forEach((el) => el.classList.add('hide'));
      // dim は初期化で消してるならここは任意
    }
  }
  // -------------------------------------- Flap アニメーション再生
  function actionOpen() {
    // 再生中なら何もしない（連打防止）※必要に応じて外してもOK
    if (!modelViewer.loaded || !modelViewer.paused) return;

    const duration = modelViewer.duration;
    const currentTime = modelViewer.currentTime;

    console.log(`🔴現在位置: ${currentTime} / 全体長さ: ${duration}`);

    // 判定ロジックの修正:
    // 「現在位置がほぼ最後(残り0.05秒以下)」なら逆再生
    // それ以外（0秒地点や途中）なら順再生
    // ※ duration が 0 の場合のエラー回避も念のため入れています
    const isAtEnd = duration > 0 && currentTime >= duration - 0.05;

    if (isAtEnd) {
      // ボタンからクラス名削除
      btnOpen.classList.remove('selected');

      modelViewer.pause();
      // --- 逆再生 (戻す) ---
      console.log('🔴判定: 最後なので -> 逆再生スタート');

      modelViewer.timeScale = -1;
      // modelViewer.currentTime = modelViewer.duration;
      modelViewer.play({
        repetitions: 1, // repetitions: 1 繰り返し回数
      });

      btnOpenIconOverlay('Close');
    } else {
      // ボタンにクラス名追加
      btnOpen.classList.add('selected');

      // --- 順再生 (進む) ---
      console.log('🔴判定: 最初(または途中)なので -> 順再生スタート');

      modelViewer.timeScale = 1;
      modelViewer.play({
        repetitions: 1, // repetitions: 1 繰り返し回数
      });

      btnOpenIconOverlay('Open'); //
    }
  }

  function actionHide() {
    console.count('actionHide fired');
    // Flap一式のマテリアルを取得する
    const materialFlap30 = modelViewer.model.getMaterialByName('Flap_30_bake');
    const materialFlap45 = modelViewer.model.getMaterialByName('Flap_45_bake');
    const materialSpacer = modelViewer.model.getMaterialByName('Spacer');
    const materialScrew = modelViewer.model.getMaterialByName('Screw-of-flap');

    if (!btnHide.classList.contains('selected')) {
      // アイコンの切り替え
      btnHideIconOverlay('Hide');
      // setAnimationReset();

      // Flapを隠す
      hidePart(materialFlap30, materialFlap45, materialScrew, materialSpacer);

      // btnOpen.style.display = "none";
      btnOpen.style.opacity = 0.3;
      btnOpen.style.pointerEvents = 'none';
      if (btnOpen.classList.contains('selected')) {
        btnOpenIconOverlay('Hide');
      }
    } else {
      // アイコンの切り替え
      btnHideIconOverlay('Show');

      // Flapを表示
      showPart(materialFlap30, materialFlap45, materialScrew, materialSpacer);

      // btnOpen.style.display = "flex";
      btnOpen.style.opacity = 1;
      btnOpen.style.pointerEvents = 'auto';
    }
  }

  function getViewerData() {
    if (typeof PRODUCT_ID === 'undefined') return null;
    const el = document.getElementById('viewerData-' + PRODUCT_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[viewerData parse error]', e);
      return null;
    }
  }

  function warmUpNextGLBs() {
    const data = getViewerData();
    if (!data || !data.byKey) return;

    const urls = Object.values(data.byKey)
      .map((v) => v && v.src)
      .filter(Boolean);

    if (!urls.length) return;

    const fetchOne = (url) => {
      fetch(url, {
        mode: 'cors',
        credentials: 'omit',
      }).catch(() => {});
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => urls.forEach(fetchOne), { timeout: 1500 });
    } else {
      // Safari 対策
      setTimeout(() => urls.forEach(fetchOne), 800);
    }

    console.log('[GLB warmup]', urls);
  }
  // ✅ 1回だけ（ボタンDOMが差し替わっても動く）
  document.addEventListener('click', (e) => {
    const t = e.target;

    if (t.closest('.viewer-ui-dimensions')) {
      // ここで毎回 “最新の” 要素を取り直す
      const dimensionLineContainer = modelViewer.querySelector(
        '.dimensionLineContainer'
      );
      const dimElements = [
        ...modelViewer.querySelectorAll('.button'),
        modelViewer.querySelector('#dimLines'),
      ].filter(Boolean);
      const dim = document.querySelectorAll('.dim');

      const isOn =
        dimensionLineContainer?.style.display === 'none' ||
        !dimensionLineContainer?.style.display;

      // selected の付け替えも「今のボタン」に対してやる
      const btnDimensions = document.querySelector('.viewer-ui-dimensions');
      btnDimensions?.classList.toggle('selected', isOn);

      // 既存の setDimensionVisibility を使うなら、setDimensionVisibility 内でも取り直すのが理想だけど
      // まずはここで直接やると確実
      if (dimensionLineContainer)
        dimensionLineContainer.style.display = isOn ? 'block' : 'none';
      dimElements.forEach((el) => el.classList.toggle('hide', !isOn));
      dim.forEach((el) => (el.style.display = isOn ? 'block' : 'none'));

      return;
    }

    if (t.closest('.viewer-ui-hide')) {
      actionHide(); // 既存関数そのまま
      return;
    }

    if (t.closest('.viewer-ui-open')) {
      actionOpen();
      return;
    }

    if (t.closest('.viewer-ui-refresh')) {
      runRefresh();
      return;
    }
  });

  function btnOpenIconOverlay(state) {
    if (state == 'Open') {
      btnOpenText.textContent = 'Close Flap';
      btnOpenIconOn.classList.add('toggle');
      btnOpenIconOff.classList.add('toggle');
    } else {
      btnOpenText.textContent = 'Open Flap';
      btnOpenIconOn.classList.remove('toggle');
      btnOpenIconOff.classList.remove('toggle');
    }
  }

  function btnHideIconOverlay(state) {
    if (state == 'Hide') {
      btnHideText.textContent = 'Show Flap';
      btnHideIconOn.classList.add('toggle');
      btnHideIconOff.classList.add('toggle');
    } else {
      btnHideText.textContent = 'Hide Flap';
      btnHideIconOn.classList.remove('toggle');
      btnHideIconOff.classList.remove('toggle');
    }
  }
});

// ------------------------------------------------------------------🟢Debug

function updateButtonText(buttonElement, status) {
  buttonElement.textContent = `SP版 モーダルモード ${status}`;
}

// ------------------------------------------------------------------🟢Debug
